import React from "react";
import { formatDate, getNumberWithOrdinal } from "../../util";
import MoreHelpPanel from "../MoreHelpPanel";
import ReviewSummaryList from "./ReviewSummaryList";
import StatusBox from "./StatusBox";

import { trackLinkOut } from "../../util/tracking";

// eslint-disable-next-line @typescript-eslint/no-var-requires
const topRightArrow: string = require("./top-right-arrow.svg");

type ArticleDetailsProps = SubmissionDetails | Record<string, never>;

const linkToStatusVideo = "https://www.youtube.com/watch?v=agTOkZvIYNY&t=81s";

const ArticleDetails = ({
  PubdNumber,
  ManuscriptTitle = "Loading article …",
  JournalName,
  CorrespondingAuthor,
  FirstAuthor,
  Status,
  SubmissionDate,
  LastUpdated,
  ReviewSummary,
  LatestRevisionNumber = 0,
  DocumentId,
  JournalAcronym
}: ArticleDetailsProps) => {
  const trackVideoLinkClicked = () => trackLinkOut({JournalAcronym, DocumentId, LatestRevisionNumber}, linkToStatusVideo);

  return (
      <>
        <div className="review-section">
          <div className="detailsbox container">
            <div className="article-title">
              <div className="title">
                <h2 className="visible-only-to-screen-reader">Article Title</h2>
                {LatestRevisionNumber === 0
                    ? ManuscriptTitle
                    : `[${getNumberWithOrdinal(
                        LatestRevisionNumber
                    )} revision] ${ManuscriptTitle}`}
              </div>
              <ReviewSummaryList
                  reviewSummary={ReviewSummary}
              />
            </div>
            <div className="detailsright">
              <StatusBox
                  status={Status}
                  lastUpdated={LastUpdated}
                  revision={LatestRevisionNumber}
              />
              <div className="visitvideo">
                <a
                    href={linkToStatusVideo}
                    onClick={trackVideoLinkClicked}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                  {"Watch to learn what we're doing behind the scenes"}
                </a>
                <img alt="arrow icon" src={topRightArrow}/>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="moredetailsbox container">
            <h2 className="visible-only-to-screen-reader">Manuscript Details</h2>
            <div className="more-details">
              <div className="moredetalsdetailcont">
                <p>
                  <strong>Journal:</strong>
                </p>
                <p>{JournalName}</p>
              </div>
              <div className="moredetalsdetailcont">
                <p>
                  <strong>Corresponding author:</strong>
                </p>
                <p>{CorrespondingAuthor}</p>
              </div>
              <div className="moredetalsdetailcont">
                <p>
                  <strong>First author:</strong>
                </p>
                <p>{FirstAuthor}</p>
              </div>
              <div className="moredetalsdetailcont">
                <p>
                  <strong>Date of submission:</strong>
                </p>
                <p>{formatDate(SubmissionDate)}</p>
              </div>
            </div>
            <div className="moredetailsright clearfix">
              <div className="contact-box">
                <div className="reference">Manuscript number:</div>
                <div className="referencenumber">
                  {LatestRevisionNumber === 0
                      ? PubdNumber
                      : `${PubdNumber}R${LatestRevisionNumber}`}
                </div>
              </div>
              <MoreHelpPanel trackingData={{DocumentId, LatestRevisionNumber, JournalAcronym}}/>
            </div>
          </div>
        </div>
      </>
)};

export default ArticleDetails;
